import React from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import DeleteIcon from '@mui/icons-material/Delete';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Box, IconButton, Paper, Stack, Typography } from '@mui/material';

export interface VoucherOption {
  voucherId: string;
  voucherName: string;
}

interface Props {
  voucher: VoucherOption;
  index: number;
  onRemove: (voucherId: string) => void;
}

export default function SortableVoucherItem({ voucher, index, onRemove }: Props) {
  const { attributes, isDragging, listeners, setNodeRef, transform, transition } = useSortable({
    id: voucher.voucherId,
  });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
  };

  return (
    <Paper ref={setNodeRef} style={style} variant="outlined" sx={{ mb: 1 }}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ p: 1 }}>
        <IconButton
          {...attributes}
          {...listeners}
          size="small"
          sx={{ cursor: 'grab', '&:active': { cursor: 'grabbing' } }}
          aria-label="Drag to reorder"
        >
          <DragIndicatorIcon fontSize="small" />
        </IconButton>
        <Typography variant="body2" color="text.secondary" sx={{ minWidth: 24 }}>
          {index + 1}.
        </Typography>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="body2" noWrap>
            {voucher.voucherName}
          </Typography>
          <Typography variant="caption" color="text.secondary" noWrap display="block">
            {voucher.voucherId}
          </Typography>
        </Box>
        <IconButton size="small" color="error" onClick={() => onRemove(voucher.voucherId)} aria-label="Remove voucher">
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Stack>
    </Paper>
  );
}
